module.exports = "/_next/static/images/by-ba5e4290f0f4167f0ac456e50fec639a.svg";